module.exports = __webpack_public_path__ + "static/media/gi.f605d362.webm";